// extracted by mini-css-extract-plugin
module.exports = {"textArea":"Textarea_textArea__pf8_S","error":"Textarea_error__mDIZY"};